import axios from '../../../utils/axios'

export default
{
    GetCustomers () {
        return axios.get('Training/Customer')
        .then(response => {
            return response.data
        })
    },
}
